const manageFiles = require.context('.', true, /\.js$/)
let languageJson = {}
const deepMerge = (target, source)=> {
for (const key in source) {
    if (source[key] instanceof Object && !Array.isArray(source[key])) {
    // 如果属性是对象，递归合并
    if (!target[key]) Object.assign(target, { [key]: {} });
    deepMerge(target[key], source[key]);
    } else {
    // 其他类型直接覆盖
    Object.assign(target, { [key]: source[key] });
    }
}
return target;
}
manageFiles.keys().forEach(key => {
  if (key === './index.js') return //    如果是当前文件，则跳过
  languageJson = deepMerge(languageJson, manageFiles(key).default)
})
export default languageJson // 